import React, { Component } from 'react';
import { Modal, message, DatePicker } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { MonthPicker } = DatePicker;

class ReSolidifyModal extends Component {
    state = {
        visible: false,
        loading: false,
        yearMonth: '',
    }

    show = () => {
        const preMonth = moment().subtract(1, 'month').format('YYYY-MM');
        this.setState({ visible: true, yearMonth: preMonth });
    }

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            yearMonth: '',
        });
    }

    confirm = () => {
        const { yearMonth } = this.state;
        const url = API_URL.home.createContractBackReport;

        if (!yearMonth) {
            message.warning('请选择重新固化月份');
            return;
        }

        this.setState({ loading: true });

        const options = {
            method: 'POST',
            url,
            data: {   
                year: yearMonth.split('-')[0],
                month: yearMonth.split('-')[1],
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleMonthChange = (date, dateString) => {
        this.setState({ yearMonth: dateString })
    }

    disabledDate = (current) => {
		// 只能选择上月及之前的月份
		return current && current.valueOf() > moment().subtract(1, 'month').endOf('month').valueOf();
	}
    render() {
        const { visible, loading, yearMonth } = this.state;
        return (
            <Modal
                title="重新固化数据"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={loading}
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <label>请选择重新固化月份</label>
                    <MonthPicker
                        allowClear={false}
                        style={{ margin: '0px 0px 10px 10px', width: 180 }}
                        disabledDate={this.disabledDate}
                        value={yearMonth ? moment(yearMonth) : null}
                        placeholder="请选择月份"
                        onChange={this.handleMonthChange}
                    />
                </div>
            </Modal>
        )
    }
}

export default ReSolidifyModal;


// WEBPACK FOOTER //
// ./src/components/homePage/returnedMoney/ReSolidifyModal.js